import api from "./api";

const namespaced = true;

const state = {};

const mutations = {};

const actions = {
  getAiPromptByName({ commit }, name) {
    return api
      .getAiPromptByName(name)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  updateAiPrompts({ commit }, { name, prompt, response }) {
    return api
      .updateAiPrompts(name, prompt, response)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
};

const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
